import React from "react";
import "./UIRTMButton.css";

export default function UIRTMButton({
  title,
  onClick,
  disabled = false,
  loading = false,
  icon,
  endIcon,
  variant = "primary",
}) {
  return (
    <button
      className={`ui-btn ${variant} ${disabled ? "disabled" : ""} ${loading ? "loading" : ""}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <span className="loader"></span>
      ) : (
        icon && <span className="icon left">{icon}</span>
      )}

      <span className="label">{title}</span>

      {!loading && endIcon && <span className="icon right">{endIcon}</span>}
    </button>
  );
}